import React from 'react';
import { connect } from 'react-redux';
import { without, orderBy, assign } from 'lodash';
import { Button } from 'ui';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import NewQuestionField from './NewQuestionField';

class QuestionFieldContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionFields: this.props.questionFields
        ? this.props.questionFields
        : [],
    };
    this.addField = this.addField.bind(this);
    this.removeField = this.removeField.bind(this);
    this.updateField = this.updateField.bind(this);
    this.renderFields = this.renderFields.bind(this);
  }

  addField() {
    request
      .post(routes.CREATE_QUESTION_FIELD(this.props.questionId))
      .then(payload => {
        if (payload.success) {
          this.setState(state => ({
            questionFields: [...state.questionFields, payload.question_field],
          }));
        } else {
          /** @todo 'error' is set in state but we're not actually handling it */
          // eslint-disable-next-line react/no-unused-state
          this.setState({ error: true });
        }
      })
      /** @todo 'error' is set in state but we're not actually handling it */
      // eslint-disable-next-line react/no-unused-state
      .fail(() => this.setState({ error: true }));
  }

  removeField(questionField) {
    request
      .delete(questionField.destroy_path)
      .then(payload => {
        this.setState(state => ({
          questionFields: without(state.questionFields, questionField),
        }));
      })
      /** @todo 'error' is set in state but we're not actually handling it */
      // eslint-disable-next-line react/no-unused-state
      .fail(() => this.setState({ error: true }));
  }

  updateField(field, index) {
    const fields = [...this.state.questionFields];

    this.setState({
      questionFields: assign(fields, { [index]: field }),
    });
  }

  renderFields() {
    const { i18n } = this.props;
    const titles = {};
    const questionFields = orderBy(this.state.questionFields, 'created_at');

    return questionFields.map((questionField, index) => {
      let isDuplicate = false;
      const title = questionField.title
        ? questionField.title.toLowerCase()
        : '';
      if (Object.prototype.hasOwnProperty.call(titles, title) && title) {
        isDuplicate = true;
      } else {
        titles[title] = true;
      }

      return (
        <NewQuestionField
          key={questionField.id}
          data={questionField}
          i18n={i18n}
          onDelete={this.removeField}
          onUpdate={field => this.updateField(field, index)}
          isDuplicate={isDuplicate}
        />
      );
    });
  }

  render() {
    const { i18n } = this.props;

    return (
      <div>
        <div className="EditorElement-label mb-12">
          {i18n.lesson_builder.secondary_fields.instructions}
        </div>
        <div className="QuestionFields">{this.renderFields()}</div>
        <Button icon="add" tall onClick={this.addField}>
          {i18n.lesson_builder.secondary_fields.add}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.editor.i18n.questions.question.ticket_handling,
});

export default connect(mapStateToProps)(QuestionFieldContainer);
